import { Select } from 'components/ui';
import styled from 'styled-components';

export const SelectFullWidth = styled(Select)`
  width: 100%;
`;
